import React from 'react';
import {withRouter} from 'react-router-dom';

const BackButton = ({history, label = 'Back'}) => (
  <button type="button" className="back-button" onClick={() => history.goBack()}>
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
      <path d="M15 6l-6 6 6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
    {label}
  </button>
);

export default withRouter(BackButton);
